import React from 'react';
import './GlobalImpact.css';

const GlobalImpact = () => {
    return (
        <section className="global-impact">
            <div className="global-impact-container">
                <div className="impact-content">
                    <span className="section-label">Global Impact</span>
                    <h2 className="impact-title">Trusted Worldwide</h2>
                    <div className="impact-text">
                        <p>
                            With over <strong>400 successful missions</strong> and a proven track record
                            spanning three decades, Partsol has established itself as a leader in
                            Cognitive Intelligence and data-driven intelligence. Our proprietary
                            technologies ensure accuracy, reliability, and adaptability to meet even
                            the most complex demands.
                        </p>
                        <p>
                            Our Cognitive Intelligence methodologies have influenced decisions involving
                            nearly <strong>$1 trillion</strong> in combined assets, empowering Fortune 50 companies,
                            defense organizations, government agencies and industry leaders worldwide.
                        </p>
                    </div>
                    <div className="impact-stats">
                        <div className="stat-item">
                            <span className="stat-number">400+</span>
                            <span className="stat-label">Successful Missions</span>
                        </div>
                        <div className="stat-divider"></div>
                        <div className="stat-item">
                            <span className="stat-number">~$1T</span>
                            <span className="stat-label">Assets Influenced</span>
                        </div>
                        <div className="stat-divider"></div>
                        <div className="stat-item">
                            <span className="stat-number">30+</span>
                            <span className="stat-label">Years of Excellence</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GlobalImpact;
